module.exports = __webpack_public_path__ + "img/icon_nav_msg_hover.a50904a5.svg";